"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var handleEvent_1 = require("../assets/handleEvent");

var memoize_one_1 = require("@stoplight/memoize-one");

var ItemsHolder =
/** @class */
function (_super) {
  __extends(ItemsHolder, _super);

  function ItemsHolder() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeItem = function () {
      var length = _this.props.items.length;
      var activeItem = _this.state.activeItem;
      var isActiveNotInRange = activeItem >= length || activeItem < 0;

      if (!activeItem || isActiveNotInRange) {
        return 0; // default active item will be the first one
      }

      return activeItem;
    };

    _this.getItems = memoize_one_1.default(function (activeItem, ItemComponent) {
      var _a = _this.props,
          items = _a.items,
          fluid = _a.fluid;

      if (!items.length) {
        return null;
      }

      return items.map(function (props, index) {
        var isActive = index === activeItem;
        return React.createElement(ItemComponent, __assign({}, props, {
          active: isActive,
          key: index,
          onClick: _this.onItemClick(index),
          fluid: fluid
        }));
      });
    });
    return _this;
  }

  ItemsHolder.getDerivedStateFromProps = function (props, state) {
    var _a;

    return __assign(__assign({}, state), {
      activeItem: (_a = props.activeItem) !== null && _a !== void 0 ? _a : state.activeItem
    });
  };

  ItemsHolder.prototype.onItemClick = function (index) {
    var _this = this;

    return function (e) {
      handleEvent_1.handleEvent(_this.props.onClick, index, e);
    };
  };

  return ItemsHolder;
}(React.PureComponent);

exports.default = ItemsHolder;